import { authGuard } from '../services/guards/auth.guard';
import { permissionGuard } from '../services/guards/permission.guard';
import { PermissionValue, ResourceValue } from '../services/permissions/permissions.types';
import { TitleTranslateResolver } from '../services/translate/title-translate.resolver';
import { provideMissingProgrammingRecordsListing } from '../pages/equipment/issue-monitoring/missing-programming-records/listing/missing-programming-records-listing.providers';
import { PortalPath, PortalRoute, PortalRouteData, RouteItem } from './app.types';
import { TranslateRegistry } from '../services/translate/translate.registry';

export const issueMonitoringRoutes: PortalRoute = {
  path: PortalPath.issueMonitoring,
  canMatch: [authGuard, permissionGuard],
  data: {
    routeItem: new RouteItem({
      path: PortalPath.issueMonitoring,
      group: TranslateRegistry.get.MAIN_MENU.SECTION.EQUIPMENT,
      title: TranslateRegistry.get.MAIN_MENU.TITLE.ISSUE_MONITORING,
      hasRight: {
        resourceValue: ResourceValue.ISSUE_MONITORING,
        targetPermissionValue: PermissionValue.VIEW
      },
      icon: 'format-list-bulleted-square',
      isNonNavigable: true
    })
  } satisfies PortalRouteData,
  children: [
    {
      path: '',
      redirectTo: PortalPath.missingProgrammingRecords,
      pathMatch: 'full'
    },
    {
      path: PortalPath.missingProgrammingRecords,
      title: TitleTranslateResolver,
      canMatch: [permissionGuard],
      data: {
        hasListingLayout: true,
        routeItem: new RouteItem({
          title: TranslateRegistry.get.MAIN_MENU.TITLE.MISSING_PROGRAMMING_RECORDS,
          path: `${PortalPath.issueMonitoring}/${PortalPath.missingProgrammingRecords}`,
          hasRight: {
            resourceValue: ResourceValue.MISSING_PROGRAMMING_RECORDS,
            targetPermissionValue: PermissionValue.VIEW
          }
        }),
        titleTranslation: TranslateRegistry.get.MAIN_MENU.TITLE.MISSING_PROGRAMMING_RECORDS
      },
      loadComponent: () =>
        import('../pages/equipment/issue-monitoring/missing-programming-records/missing-programming-records.component').then(
          c => c.MissingProgrammingRecordsComponent
        ),
      providers: provideMissingProgrammingRecordsListing()
    }
  ]
};
